<template>
  <div class="mark-side-wrap">
    <div class="title-wrap">
      <img v-if="type ==='img'" class="icon-img" :src="`/static/${iconName}`" alt="">
      <a-icon v-else :type="iconName" :style="{color: '#2279D2'}"/>
      <span class="text">{{title}}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    iconName: String,
    title: String,
    type: String
  },
  data() {
    return {

    }
  },
  components: {

  }
}
</script>
